import Button from '@atlaskit/button/new';
import React, { useCallback } from 'react';
import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { type Props } from './types';

export const InlineJoinButton = ({
	children,
	onClick,
	triggerInlineJoin,
	isInlineJoinPending,
}: Props) => {
	const onClickHandler = useCallback(
		(e: React.MouseEvent, analyticsEvent: UIAnalyticsEvent) => {
			// do the inline-join
			triggerInlineJoin();
			onClick(e, analyticsEvent);
		},
		[triggerInlineJoin, onClick],
	);

	const buttonProps = isInlineJoinPending ? { isLoading: true } : { onClick: onClickHandler };

	return (
		<Button appearance="primary" {...buttonProps}>
			{children}
		</Button>
	);
};
